export default "__VITE_ASSET__BJwbqE$I__"